import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

/**
 * Shown after login when guest review drafts (written while signed out) collide
 * with reviews the account already has for the same target. The backend allows
 * only one review per target, so the user picks per item: keep their existing
 * review, or replace it with the draft. Conflicts are resolved one at a time —
 * as each is handled it leaves the queue and the next appears. See issue #13.
 */
function GuestReviewConflictModal() {
  const { guestReviewConflicts, resolveReviewConflict } = useAuth();

  const conflict = guestReviewConflicts && guestReviewConflicts[0];
  if (!conflict) return null;

  const targetName = conflict.draft?.target?.name || 'this item';
  const canReplace = !!conflict.existingReviewId;

  return (
    <Modal show onHide={() => resolveReviewConflict(conflict, 'keep')} centered>
      <Modal.Header closeButton>
        <Modal.Title>You already reviewed {targetName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          While signed out, you drafted a review for <strong>{targetName}</strong>,
          but your account already has one. Which would you like to keep?
        </p>
        {conflict.draft?.review_text && (
          <blockquote className="border-start ps-3 text-muted small mb-0">
            “{conflict.draft.review_text}”
          </blockquote>
        )}
        {!canReplace && (
          <p className="text-muted small mt-2 mb-0">
            (We couldn't load your existing review to replace it, so your draft is
            kept on this device for now.)
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => resolveReviewConflict(conflict, 'keep')}>
          Keep my existing review
        </Button>
        <Button variant="primary" disabled={!canReplace} onClick={() => resolveReviewConflict(conflict, 'replace')}>
          Use my draft instead
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default GuestReviewConflictModal;
